export default __webpack_public_path__ + "static/media/placeholder_business08-jp-mobile.c0dd75c5.png";